import { AppUser } from '@/api/models';
import { UserSessionModel } from '@/db/models';
import { getUser, setUser } from '@/library/UserSessionHelper';
import { ModuleName, modules } from '@/constants';
import { ITourPageSettings } from './TourPageSettingsHelper';

// Fetches user settings (like subnav order) from the backend and persists them to the local session.
export const saveUserSettings = async (appUser: AppUser) => {
  try {
    // appSectionId 8 is used for the subnav order setting per TA-1136
    const subnavSetting = appUser.appUserSetting?.find((s) => s.appSectionId === 8);

    // Save Subnav settings
    if (subnavSetting && subnavSetting.setting) {
      const user = await getUser();
      if (user) {
        user.subnavOrder = subnavSetting.setting;
        await setUser(user);
      }
    }
  } catch (error) {
    console.error('Failed to fetch user settings:', error);
  }
};

// Parses the subnavOrder from the user session and returns a validated ModuleName array.
export const getParsedSubnavOrder = (user: UserSessionModel | null): ModuleName[] => {
  const subnavData = user?.subnavOrder ? JSON.parse(user.subnavOrder) : null;
  const subnavString = subnavData?.subnav;

  if (!subnavString) return [...modules];

  const savedOrder = subnavString.split('|').map((moduleName: string) => moduleName.trim());
  // Casting to ModuleName from stored strings
  const validModules = savedOrder.filter((moduleName: string) => modules.includes(moduleName as ModuleName)) as ModuleName[];

  return [...new Set([...validModules, ...modules])];
};

const restrictedOfflineModules: ModuleName[] = ['Transfer Club']; // Offline hidden modules
const restrictedModules: ModuleName[] = ['Loft & Lie', 'Transfer Club', 'Player Info']; // Restricted modules

// Returns the subset of moduleOrder that is visible given the current online status and permissions.
export const getAvailableModules = (moduleOrder: ModuleName[], isOnline: boolean, tourPageSettings: ITourPageSettings | undefined): ModuleName[] => {
  // Checks if any of the tour pages have 'full' access.
  const isFullAccess = Object.values(tourPageSettings || {}).some((module) => module === 'full');

  return moduleOrder.filter((module) => {
    if (!isOnline && restrictedOfflineModules.includes(module)) return false;
    if (!isFullAccess && restrictedModules.includes(module)) return false;
    return true;
  });
};
